import {createRouter, createWebHistory} from 'vue-router'
import {createAuthGuard} from "@auth0/auth0-vue";

/* Layout */
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: () => import('@/menu/context/components/layout/LayoutMenu.vue'),
      name: 'dashboard',
      beforeEnter: createAuthGuard(app),
    },
    {
      path: '/portal/:id',
      component: () => import('@/menu/context/components/layout/LayoutMenu.vue'),
      name: 'portal',
      props: true,
      beforeEnter: createAuthGuard(app),
    },
    {
      path: '/portal/:id/:path',
      component: () => import('@/menu/context/components/layout/LayoutMenu.vue'),
      name: 'submenu',
      props: true,
      beforeEnter: createAuthGuard(app),
    },
    {
      path: '/in-active-user',
      name: 'in-active-user',
      beforeEnter: createAuthGuard(app),
      component: () => import('@/menu/context/views/InActiveUser.vue')
    },
    {
      path: '/user-not-found',
      name: 'user-not-found',
      beforeEnter: createAuthGuard(app),
      component: () => import('@/menu/context//views/UserNotFound.vue')
    },
    {
      path: '/internal-error',
      name: 'internal-error',
      beforeEnter: createAuthGuard(app),
      component: () => import('@/menu/context/views/SystemError.vue')
    },
    {
      path: '/unathorized-from-outside',
      name: 'unathorized-from-outside',
      beforeEnter: createAuthGuard(app),
      component: () => import('@/menu/context/views/UnauthorizedFromOutsideError.vue')
    },
    {
      path: '/external-without-projects',
      name: 'external-without-projects',
      beforeEnter: createAuthGuard(app),
      component: () => import('@/menu/context/views/ExternalWithoutProjects.vue')
    },
    {
      path: '/:catchAll(.*)',
      redirect: '/'
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.name === 'dashboard' && from.path === '/portal/X6bPvZ3wRt9A2eF1cV7') {
    const iframe = document.getElementById("myIframe");
    iframe.contentWindow.postMessage("iframeToDestroy", "*");

    setTimeout(() => {
      next();
    }, 500);
  } else {
    next()
  }
})
export default router

